import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { SidebarLayout } from '@/components/layouts/SidebarLayout'

export default function New() {
  const { data, setData, post, processing, errors } = useForm({
    skill: {
      name: '',
      description: '',
      content: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/manage/skills')
  }

  return (
    <SidebarLayout section="manage" title="New skill">
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          maxWidth: 800,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Name"
            fullWidth
            autoFocus
            value={data.skill.name}
            onChange={e => setData('skill', { ...data.skill, name: e.target.value })}
            error={'skill.name' in errors}
            helperText={(errors as Record<string, string>)['skill.name'] || 'e.g. commit, review-pr'}
            sx={{ mb: 2.5 }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={2}
            value={data.skill.description}
            onChange={e => setData('skill', { ...data.skill, description: e.target.value })}
            error={'skill.description' in errors}
            helperText={(errors as Record<string, string>)['skill.description']}
            sx={{ mb: 2.5 }}
          />
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            SKILL.md content (YAML frontmatter + markdown instructions)
          </Typography>
          <TextField
            label="Content"
            fullWidth
            multiline
            minRows={12}
            value={data.skill.content}
            onChange={e => setData('skill', { ...data.skill, content: e.target.value })}
            error={'skill.content' in errors}
            helperText={(errors as Record<string, string>)['skill.content']}
            sx={{ mb: 3, '& .MuiInputBase-input': { fontFamily: 'monospace', fontSize: '0.85rem' } }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={processing}
            sx={{ mb: 2 }}
          >
            Create skill
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Link href="/manage/skills" style={{ color: '#1a1a1a' }}>Back to skills</Link>
          </Box>
        </Box>
      </Paper>
    </SidebarLayout>
  )
}
